import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { PaginationData, PagingParams } from "../../types/pagination";
import toast from "react-hot-toast";
import { ClientNotifyRequest, PaymentData } from "../../types/booking";
import { ActionResult } from "../../types";

class PaymentStore {
  payments = [];
  currentPayment = null;
  paymentUrl = null;
  status = "";
  error = null;
  loading = false;
  pagination: PaginationData | null = null;
  pagingParams = new PagingParams();
  searchTerm: string = "";
  fromDate: string | null = null;
  toDate: string | null = null;
  gideastatus: "Idle" | "Completed" | "Failed" | "Pending" = "Idle";
  constructor() {
    makeAutoObservable(this);
  }


createGeideaSession = async (payload: {
  amount: number;
  currency: string;
  merchantReferenceId: string;
}): Promise<{ sessionId: string }> => {
  const response = await agent.Payment.createGeideaSession(payload);
  return response;
};


 notifyPaymentResult = async (payload: ClientNotifyRequest) => {
    this.loading = true;
    this.error = null;

    try {
      await agent.Payment.notifyGeideaResult(payload);

      runInAction(() => {
        if (payload.paymentStatus === "SUCCESS") this.status = "Completed";
        else if (payload.paymentStatus === "CANCELLED") this.status = "Failed";
        else this.status = "Failed";
        this.error = null;
      });

      return { status: "success" as const };
    } catch (err: any) {
      runInAction(() => {
        this.error = err?.message || "Failed to notify payment result";
        this.status = "Failed";
      });
      return { status: "error" as const, error: this.error };
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  };



initiatePayment = async (paymentData: FormData) => {
  this.loading = true;
  try {
    const response = await agent.Payment.initiate(paymentData);
    return { status: "success", data: response };
  } catch (error: any) {
    runInAction(() => {
      this.error = error.message;
      this.paymentUrl = null;
      this.status = "Failed";
    });
    return { status: "error", error: this.error };
  } finally {
    this.loading = false;
  }
};



  // // Initiate Payment
  // initiatePayment = async (paymentData: FormData) => {
  //   this.loading = true;
  //   try {
  //     const response = await agent.Payment.initiate(paymentData);
  //     return { status: "success", data: response };
  //   } catch (error: any) {
  //     runInAction(() => {
  //       this.error = error.message;
  //       this.paymentUrl = null;
  //       this.status = "Failed";
  //     });
  //     return { status: "error", error: this.error };
  //   } finally {
  //     this.loading = false;
  //   }
  // };
  //  processGooglePayPayment=async (paymentData: any)=> {
  //   try {
  //     const response = await agent.Payment.processGooglePayPayment(paymentData);
  //     return response;
  //   } catch (error) {
  //     toast.error("Error processing payment.");
  //     return null;
  //   }
  // }

//upload receipt
  uploadBankTransferReceipt = async (formData: FormData) => {
    try {
      const response = await agent.Payment.uploadBankTransferReceipt(formData);
      return response;
    } catch (error) {
      console.error("Upload failed:", error);
      throw error;
    }
  };


  // Handle Payment Callback


handlePaymentCallback = async (orderId: string, paymentStatus: string) => {
  this.loading = true;

  const formData = new FormData();
  formData.append("orderId", orderId);
  formData.append("paymentStatus", paymentStatus);

  try {
    await agent.Payment.callback(formData);
    runInAction(() => {
      this.status = paymentStatus === "SUCCESS" ? "Completed" : "Failed";
      this.error = null;
    });
    return { status: "success", data: "Payment processed successfully" };
  } catch (error: any) {
    runInAction(() => {
      this.error = error.message || "Failed to handle payment callback";
      this.status = "Failed";
    });
    return { status: "error", error: this.error };
  } finally {
    this.loading = false;
  }
};



  // handlePaymentCallback = async (orderId: string, paymentStatus: string) => {
  //   this.loading = true;

  //   const formData = new FormData();

  //   formData.append("orderId", orderId);
  //   formData.append("paymentStatus", paymentStatus);
  //   try {
  //     await agent.Payment.callback(formData);
  //     runInAction(() => {
  //       if (paymentStatus === "SUCCESS") {
  //         this.status = "Completed";
  //       } else {
  //         this.status = "Failed";
  //       }
  //       this.error = null;
  //     });
  //     return { status: "success", data: "Payment processed successfully" };
  //   } catch (error: any) {
  //     runInAction(() => {
  //       this.error = error.message || "Failed to handle payment callback";
  //       this.status = "Failed";
  //     });
  //     return { status: "error", error: this.error };
  //   } finally {
  //     this.loading = false;
  //   }
  // };



  //   // Load Payment by ID
  //   getPaymentById = async (id) => {
  //     this.loading = true;
  //     try {
  //       const payment = await agent.Payment.getById(id);
  //       runInAction(() => {
  //         this.currentPayment = {
  //           ...payment,
  //           createDate: formatDateTime(payment.createDate),
  //         };
  //         this.error = null;
  //       });
  //     } catch (error:any) {
  //       runInAction(() => {
  //         this.error = error.message || "Failed to load payment details";
  //       });
  //     } finally {
  //       this.loading = false;
  //     }
  //   };

  // Clear Payment State
  clearPayment = () => {
    this.paymentUrl = null;
    this.status = "";
    this.error = null;
    this.loading = false;
  };

  setPagingParams = (pagingParams: PagingParams) => {
    this.pagingParams = pagingParams;
  };

  setPagination = (pagination: PaginationData) => {
    this.pagination = pagination;
  };

  setSearchTerm = (term: string) => {
    this.searchTerm = term;
  };

  setDateFilter = (from: string | null, to: string | null) => {
    this.fromDate = from;
    this.toDate = to;
  };
}

export default PaymentStore;
